import {IMessageType} from "../../index";
import {IType, TType} from "./index";
import {nsMessages} from "./fn";
import * as ko from "knockout";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import {global} from "../../appContext";
import CustomMessageTypes = nsMessages.CustomMessageTypes;
import getMainType = nsMessages.getMainType;
import getSubType = nsMessages.getSubType;
import type2id = nsMessages.type2id;
import getMinorType = nsMessages.getMinorType;

export class MutableMessageType {

    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    public mainType: KnockoutObservable<IType | null> = ko.observable(null);
    public subType: KnockoutObservable<IType | null> = ko.observable(null);
    public minorType: KnockoutObservable<IType | null> = ko.observable(null);
    private availableMainTypes: IType[];

    constructor(private messageType: KnockoutObservable<IMessageType | null>, private messageTypes: IMessageType[]) {
        this.kosub.subscribe([this.mainType, this.subType, this.minorType], () => {
            this.messageType(this.getMessageType());
        });
        this.setMainAndSubTypes();

        const availableMainTypes: TType[] = ['sms', 'email'];
        const org = global.login.selectedOrganization();
        if (org?.ehub) {
            availableMainTypes.push('eadm')
        }
        this.availableMainTypes = availableMainTypes.map(k => CustomMessageTypes[k]);
    }

    private setMainAndSubTypes() {
        const name = this.messageType()?.name;
        if (name) {
            this.mainType(getMainType(name));
            this.subType(getSubType(name));
            this.minorType(getMinorType(name));
        }
    }

    private getMessageType(): IMessageType | null {
        const findMessageType = (arr: (IType | null)[]): IMessageType | null => {
            if (!arr.length) {
                return null;
            }
            const key = arr.filter(Boolean).map(t => t!.key).join(' ');
            const id = type2id[key];
            if (id) {
                return this.messageTypes.find((mt: IMessageType) => mt.id == id) ?? null;
            } else {
                arr.pop();
                return findMessageType(arr);
            }
        }
        return findMessageType([this.mainType(), this.subType(), this.minorType()]);
    }

    availableSubTypes = ko.pureComputed((): IType[] => {
        if (!this.mainType()) {
            return [];
        }
        return this.getSubKeys().map((key: TType) => CustomMessageTypes[key]);
    });

    availableMinorTypes = ko.pureComputed((): IType[] => {
        if (!this.mainType() || !this.subType()) {
            return [];
        }
        return this.getMinorKeys()?.map((key: TType) => CustomMessageTypes[key]) ?? [];
    });

    private getSubKeys(): TType[] {
        switch (this.mainType()!.key) {
            case 'sms':
                return ['user', 'manager', 'custom'];
            case 'email':
                return ['user', 'manager', 'custom'];
            case 'eadm':
                return ['user', 'manager'];
            default:
                return [];
        }
    }

    private getMinorKeys(): TType[] | null {
        if (this.mainType()!.key == 'eadm' && this.subType()) {
            return ['task', 'message'];
        }
        return null;
    }

    public getKeys(): TType[] {
        return [this.mainType(), this.subType(), this.minorType()]
            .filter((t): t is IType => t != null)
            .map(t => t.key);
    }

}